import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { SortTypeEnum } from "@pg-app/shared/enums/sort-type.enum";
import { environment } from "@pg-env/environment";
import { PayerColumns } from "../constants/payer-table-column-constant";
import { ApprovedPayerService } from "../services/approved-payer-service";

@Component({
    selector: 'np-manage-approved-payer',
    templateUrl: './approved-payers.component.html',
    styleUrls: ['./approved-payers.component.scss']
  })
  export class ApprovedPayersComponent implements OnInit {

    searchPayer: FormGroup;
    rows: Array<any> = [];
    columns = JSON.parse(JSON.stringify(PayerColumns));
  totalItems: any;
  initialPage: any;
  isLoading: boolean;

    constructor(private fb: FormBuilder,
      private router: Router, private payerService: ApprovedPayerService) {
      
    }
    ngOnInit(): void {
      this.searchPayer = this.fb.group({
        searchText: ''
      });
      this.getPayers();
    }

    addNewApprovedPayer()
    {
      this.router.navigate(['client/approved-payers/add-new-approved-payer']);
    }

    getPayers(paging = null)
    {
      const filters = paging?.filter && paging.filter.length > 0 ? paging.filter : null;

      if (filters) {
        const filterAccountNumberIban = filters.find(item => item.propertyName === 'AccountNumberIban');
        if (filterAccountNumberIban) {
          filters.splice(filters.indexOf(filterAccountNumberIban), 1);
          filters.push({
            propertyName: 'AccountNumber',
            propertyValue: filterAccountNumberIban.propertyValue
          });
          filters.push({
            propertyName: 'Iban',
            propertyValue: filterAccountNumberIban.propertyValue
          });
        }
  
        const filterPaymentMandate = filters.find(item => item.propertyName === 'PaymentMandate');
        if (filterPaymentMandate) {
          filterPaymentMandate.propertyName = 'PaymentMandateText';
        }
      }
      const getPayerName = {
        clientId: null,
        legalName: this.searchPayer.get('searchText').value,
        pageSize: environment.defaultPageSize,
        pageIndex: paging ? paging.currentPage : 1,
        sortName: paging?.sortName || 'LastUpdatedDate',
        sortType: paging?.sortName ? paging.sortType : SortTypeEnum.Desc,
        filters: filters || null
      };

      this.payerService.getPayerList(getPayerName).subscribe(
        res => {
          const data = res.payers || [];
          if (data && data.length > 0) {
            data.forEach(item => {
              item.accountNumberIban = item.iban && item.accountNumber ? item.accountNumber + '/' + item.iban : item.iban || item.accountNumber;
            });
          }
          this.rows = data;
          this.totalItems = res.pagination.totalItems;
          this.initialPage = res.pagination.pageIndex;
  
          this.isLoading = false;
        },
      );
    }
}